/**
 * CTA tıklamasında dataLayer'a event push eder.
 * @param {object} dataLayerPayload - Section config'den gelen payload (event, event_category vb.)
 * @param {string} cta_button - Tıklanan CTA'nın etiketi (örn: kart başlığı)
 */
export function pushCtaClickDataLayer(dataLayerPayload, cta_button) {
  if (typeof window === "undefined" || !dataLayerPayload) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ...dataLayerPayload,
    cta_button: cta_button ?? "",
  });
}
